import { adminHttpClient } from '../../../../../commons/adminHttpClient'
import { Moment } from 'moment'
import AllowanceType from '../../../../../../domain/benefit/allowanceType'
import { WizardStatus } from '../../../../../../domain/wizard/wizard'

export interface ProductClass {
  id: string | null
  name: string | null
  benefitStartDate: Moment
  benefitEndDate: Moment
  benefitAllowanceType: AllowanceType
  classType: {
    id: number
    name: string
  } | null
  offerSameAllowance: boolean | null
  requiresEOB: boolean | null
  requiresPrescription: boolean | null
  deductable: boolean | null
  productClassDeductible: [
    {
      familyStatusId: number
      amount: number
    },
  ]
  eeCoinsurance: boolean | null
  eeCoinsuranceAmount: number | null
  eobExpense: {
    id: number
    name: string
  }[]
  productClassAllowance: [
    {
      familyStatusId: number
      amount: number
    },
  ]
  waitingPeriod: number | null
  wizardStatus: WizardStatus
  prorateAllowancesHire: boolean | null
  prorateAllowancesTerminate: boolean | null
}

export const getProductClassWizardState = (planPeriodId: string, productClassId?: string): Promise<any> => {
  if (productClassId)
    return adminHttpClient.get(`/AdminDashboard/BenefitDetails/BenefitDesignClasses/${planPeriodId}/${productClassId}`)
  return adminHttpClient.get(`/AdminDashboard/BenefitDetails/BenefitDesignClasses/${planPeriodId}`)
}
